import * as React from 'react';
type Props = {
  className?: string;
};
export function Turkey({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Turkey"
      className={className}
    >
      <path
        d="M11.3784 27.5337C9.80495 27.1724 7.44033 26.6394 6.03033 26.3212C5.30799 26.1579 4.83504 26.0549 4.83504 26.046C4.80932 26.046 4.03545 27.6971 2.64251 27.4906C1.64508 27.353 1.06906 26.2526 1.30123 25.2294C1.46455 24.5585 1.62788 24.1631 2.10083 23.7934C1.83422 22.8476 1.86865 22.7875 2.02337 22.1167C2.26414 21.0935 3.25307 20.4401 4.22458 20.672C5.1962 20.8958 5.79816 21.9104 5.55738 22.9335C5.55738 23.0024 7.07066 23.4323 8.79032 23.9136C9.73622 24.1716 10.7422 24.4468 11.5935 24.679C11.2065 25.2723 11.1291 26.4072 11.3784 27.5337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3335 35.916C14.8026 35.9463 9.77078 35.3148 6.33815 34.0213C4.67787 33.3899 3.73059 31.4748 3.8936 29.7127C3.99543 28.7043 4.80011 27.5228 6.03261 26.3208C7.43832 26.6365 9.8014 27.1764 11.3801 27.533H11.4006C11.4515 27.7877 11.533 28.0626 11.6144 28.3069C11.6756 28.4497 11.7266 28.5719 11.7877 28.7043C11.8488 28.8265 11.9099 28.9487 11.9811 29.0608C13.8452 32.2184 17.1148 34.5611 20.3335 35.916Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.1304 25.9135C45.5126 29.6923 40.0531 32.4018 33.7785 34.0315C34.1554 33.614 34.4814 33.1353 34.7666 32.5954C36.6407 29.0508 35.4388 24.5077 32.7599 21.9003C32.5766 21.7168 30.0505 19.3233 26.3633 19.2926C23.0019 19.2723 20.2009 21.2279 19.2332 21.9919C17.2266 23.5706 16.5645 25.0985 14.8736 25.1189C13.3662 25.1392 12.6429 23.9374 11.9198 24.355C11.8688 24.3855 11.8077 24.4161 11.7669 24.4773C11.7364 24.4976 11.6957 24.5383 11.6753 24.5688C10.0456 24.2023 8.9557 23.9681 8.79272 23.9171C10.8808 21.8391 12.2254 19.7509 14.3339 17.235C20.6897 9.62626 32.0673 9.93183 37.1399 14.2099C37.863 14.8211 39.941 16.5629 41.9578 18.9768C43.3736 20.6677 44.1274 21.3094 45.1153 21.6965C46.0524 22.0529 46.3784 22.2872 47.2442 22.4909C48.9656 22.8985 49.1389 24.457 48.1304 25.9135Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.767 32.5954C34.4818 33.1353 34.1558 33.6141 33.779 34.0315C33.5651 34.2862 33.3308 34.5204 33.0863 34.7344C30.8659 36.7206 27.9629 37.1077 27.2295 37.2197C25.4673 37.4541 22.9209 36.9957 20.3336 35.916C17.1149 34.5613 13.8453 32.2184 11.9812 29.061C11.91 28.9488 11.8489 28.8266 11.7878 28.7043C11.7267 28.572 11.6757 28.4497 11.6146 28.3071C11.5331 28.0627 11.4516 27.7877 11.4007 27.5332H11.3802C11.1256 26.4024 11.2071 25.2717 11.5942 24.681H11.6044C11.6146 24.6504 11.6349 24.6198 11.6655 24.5893C11.6655 24.5791 11.6757 24.5791 11.6757 24.5688C11.696 24.5384 11.7368 24.4976 11.7674 24.4773C11.808 24.4162 11.8693 24.3856 11.9201 24.355C12.6434 23.9374 13.3665 25.1393 14.874 25.119C16.5649 25.0986 17.2269 23.5706 19.2336 21.9919C20.2013 21.228 23.0024 19.2723 26.3637 19.2926C30.051 19.3233 32.577 21.7169 32.7604 21.9003C35.4393 24.5078 36.6412 29.0508 34.767 32.5954Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3957 27.5337C11.4557 27.7916 11.5332 28.0581 11.6192 28.3074C11.5159 28.0494 11.4386 27.7916 11.3784 27.5337H11.3957Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
